var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.717,
    height: 37.715,
    viewBox: "0 0 30.717 37.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_234",
    "data-name": "Groupe 234",
    transform: "translate(-336.293 1237.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_319",
    "data-name": "Trac\\xE9 319",
    d: "M341.786-1237.269h15.763a3.527,3.527,0,0,0,.264.333q4.418,4.408,8.845,8.807a1.06,1.06,0,0,1,.353.829q-.016,11.672-.009,23.343c0,.221,0,.442-.015.662a3.987,3.987,0,0,1-3.235,3.658,5.7,5.7,0,0,1-.951.076q-10.144.006-20.288.006a4.1,4.1,0,0,1-2.523-.764,3.909,3.909,0,0,1-1.666-3.206c-.013-.609,0-1.218,0-1.826-1.526.023-2.054-.851-2.026-2.178.054-2.527.015-5.056.016-7.584,0-.6-.014-1.2.018-1.8a1.574,1.574,0,0,1,1.5-1.491c.155-.011.31-.016.49-.025v-.465q0-7.124,0-14.249a4.006,4.006,0,0,1,2.8-3.935C341.343-1237.149,341.565-1237.206,341.786-1237.269Zm-1.019,31.9c0,.547,0,1.036,0,1.525a1.622,1.622,0,0,0,1.832,1.836h20.106a1.615,1.615,0,0,0,1.84-1.856q-.03-11.25-.061-22.5c0-.131,0-.263,0-.434h-.472c-1.657,0-3.315.028-4.97-.021a2.635,2.635,0,0,1-2.444-2.433c-.057-1.7-.034-3.411-.047-5.117,0-.142-.014-.284-.022-.442-.133-.006-.229-.014-.325-.014q-6.831.006-13.662.015a1.6,1.6,0,0,0-1.775,1.781q0,7.126,0,14.251v.368h18.985a1.682,1.682,0,0,1,1.91,1.926c0,3.069-.021,6.138.011,9.206a1.781,1.781,0,0,1-1.935,1.923c-6.162-.03-12.324-.014-18.486-.014Zm5.67-2.939c.935,0,1.834.075,2.717-.015a3.242,3.242,0,0,0,3.267-3.448,2.937,2.937,0,0,0-2.3-3.2,9.588,9.588,0,0,0-3.686-.042Zm-5.867-6.782v6.751h1.506v-2.34c.567-.056,1.073-.065,1.56-.164a2.114,2.114,0,0,0,1.787-2.227,1.953,1.953,0,0,0-1.906-2C342.548-1215.168,341.565-1215.093,340.569-1215.093Zm12.9,0v6.752h1.524v-2.723H357.4v-1.242h-2.4v-1.567h2.577v-1.221Z",
    fill: "#51b4d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_320",
    "data-name": "Trac\\xE9 320",
    d: "M455.8-994.742v-4.36a2.28,2.28,0,0,1,2.411.652,2.892,2.892,0,0,1,.021,2.9A2.264,2.264,0,0,1,455.8-994.742Z",
    transform: "translate(-107.823 -214.781)",
    fill: "#51b4d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_321",
    "data-name": "Trac\\xE9 321",
    d: "M395.42-997c0-.716-.006-1.313.008-1.909a.28.28,0,0,1,.181-.2,3.682,3.682,0,0,1,.872.026.882.882,0,0,1,.768.855.953.953,0,0,1-.6,1.032A8.082,8.082,0,0,1,395.42-997Z",
    transform: "translate(-53.344 -214.857)",
    fill: "#51b4d2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.c1f5f7021174bd3b66fa3e5f774f93b4.svg";
export { ForwardRef as ReactComponent };